import { ShortStockStatus } from "../enumerations"

export interface StockShortage {
  code: string,
  requested: number,
  availableImmediately: number,
  availableAfterOtherOrdersComptlete: number
  status: ShortStockStatus
}